import { useState } from "react";
import type { FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useAuthActions } from "../session";
import { Alert, Card, Field } from "../shell/ui";

export function SignUpPage() {
  const { signup } = useAuthActions();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const set = (k: keyof typeof form) => (e: { target: { value: string } }) =>
    setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    signup.mutate(form, { onSuccess: () => navigate("/me") });
  };

  return (
    <div className="auth">
      <h1 className="page__title">Create your account</h1>
      <p className="muted">
        Free, and it stays yours: your strategies, runs, saved backtests and bots are kept. You start on the
        Starter layout and can switch to Pro whenever you like.
      </p>
      <Card>
        <form className="auth__form" onSubmit={onSubmit}>
          <Field label="Username">
            <input
              autoComplete="username"
              value={form.username}
              onChange={set("username")}
              pattern="[A-Za-z0-9_]{3,24}"
              title="3–24 letters, digits or underscores"
              required
            />
          </Field>
          <Field label="Password">
            <input
              type="password"
              autoComplete="new-password"
              value={form.password}
              onChange={set("password")}
              minLength={8}
              required
            />
          </Field>
          {signup.error && <Alert tone="error">{signup.error.message}</Alert>}
          <div className="row">
            <button className="btn btn--primary" type="submit" disabled={signup.isPending}>
              Create account
            </button>
            <Link to="/signin">Already have one? Sign in.</Link>
          </div>
          <p className="muted small">
            Paper trading only — no money, no exchange keys, no investment advice. There is no email and no
            password reset yet, so pick a password you'll remember.
          </p>
        </form>
      </Card>
    </div>
  );
}
